module.exports = __webpack_public_path__ + "static/img1-18cfc03951e413d0d1423a453b63a68c.png";